<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="columns is-multiline">
        <div class="column is-2">
          <BestPracticeNavigation :bestPractice="bestPractice"></BestPracticeNavigation>
        </div>
        <div class="column is-9">
          <div class="columns is-vcentered content">
            <div class="column is-10">
              <h1 class="title is-2">{{ bestPractice.fields.name }}</h1>
            </div>
            <div class="column is-2">
              <router-link :to="{ name: 'home' }" class="button is-info is-pulled-right">
                <font-awesome-icon icon="arrow-up"></font-awesome-icon>
                &nbsp; Vissza
              </router-link>
            </div>
          </div>

          <hr>

          <bulma-accordion
            :icon="'caret'"
            :caretAnimation="{ duration: '.6s', timerFunc: 'ease-in-out' }"
            :slide="{ duration: '.9s', timerFunc: 'ease'}"
          >
            <bulma-accordion-item>
              <div class="content" slot="title">
                <div class="anchor"><a id='dataSheet'></a></div>
                <h3 class="is-marginless">ADATLAP</h3>
                <small>(kattintson a részletekért)</small>
              </div>
              <div class="content" slot="content">
                <BestPracticeDataSheet :bestPractice="bestPractice"></BestPracticeDataSheet>
              </div>
            </bulma-accordion-item>
          </bulma-accordion>

          <hr>

          <BestPracticeDetailed :bestPractice="bestPractice"></BestPracticeDetailed>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import BestPracticeDataSheet from '@/components/BestPractice/BestPracticeDataSheet'
  import BestPracticeDetailed from '@/components/BestPractice/BestPracticeDetailed'
  import BestPracticeNavigation from '@/components/BestPractice/BestPracticeNavigation'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        bestPractice: {},
        isLoading: true
      }
    },
    async mounted () {
      /* Get Id */
      const bestPracticeId = this.$store.state.route.params.bestPracticeId
      /* Get best practice */
      this.bestPractice = (await Contentful.getSingleEntriesByContentTypeAndId('bestPractice', bestPracticeId)).data
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    components: {
      BestPracticeDataSheet,
      BestPracticeDetailed,
      BestPracticeNavigation,
      BulmaAccordion,
      BulmaAccordionItem,
      Loader
    }
  }
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>
  .accordion:hover {
    cursor: pointer;
  }

  .anchor a {
    display: block;
    position: relative;
    top: -100px;
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ViewBestPractice.vue